import { useState, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import "./About.css"
const About = () => {
  return (
    <ParallaxProvider>
      <div style={{ padding: "10px" }} className="About">
        <title>About</title>
        <div className="backGround">
          <div className="parallax-container">
            <h1 className="title">About Me</h1>
            <p className="subtitle">無いなら作れの精神で、走り続けた21年間。簡単にご紹介しましょう。</p>
          </div>

          <div className="content-row">
            <Parallax speed={-5} className="content-left">
              <div className="section">
                <h2>2021年4月、福井高専入学</h2>
                <p>2021年、福井工業高等専門学校 電子情報工学科に入学。<br />
                  軽音楽部に入ろうとするもなぜか入れず。<br />
                  ほんなら全部自分でやってやるよということで、<br />
                  作曲を開始。<br />
                  相棒は1964年製のCOLOMBIA CSG-631。<br />
                </p>
                
              </div>
            </Parallax>
            <Parallax speed={5} className="content-right">
              <div className="image-container">
                <img src="/about/csg-1.jpg" alt="2021年4月" />
              </div>
            </Parallax>
          </div>

          <div className="content-row">
           
            <Parallax speed={-5} className="content-right">
              <div className="section">
                <h2>2022年7月、ボカロP活動開始</h2>
                <p>2022年7月、YouTubeに自身初のボカロ曲、<br />
                  「ハジメテ」を投稿。<br />
                  以後もスローペースながら楽曲投稿を続ける。
                </p>
              </div>
            </Parallax>
             <Parallax speed={5} className="content-left">
              <div className="image-container">
                <img src="/about/csg-2.jpg" alt="2022年7月" />
              </div>
            </Parallax>
          </div>

          <div className="content-row">
            <Parallax speed={-5} className="content-left">
              <div className="section">
                <h2>2023年3月、花火を投稿</h2>
                <p>自身一番のヒット作となる「花火」を投稿。<br />
                  中学時代の友人とともに制作した楽曲で、出来る全てを込めた。<br />
                  ただ、その後しばらく「花火を超えられない」とスランプに陥る。<br />
                </p>
              </div>
            </Parallax>
            <Parallax speed={5} className="content-right">
              <div className="image-container">
                <img src="/music/hanabi.jpg" alt="2023年3月" />
              </div>
            </Parallax>
          </div>

          <div className="content-row">
          
            <Parallax speed={-5} className="content-right">
              <div className="section">
                <h2>2023年11月、全国制覇</h2>
                <p>第34回全国工業高等専門学校プログラミングコンテスト 競技部門にて<br />
                  グループリーダーとしてチームを導き、無敗で全国制覇を達成。<br />
                  福井高専初のプロコン全国制覇、かつ開催地での優勝となった。<br />
                </p>
              </div>
            </Parallax>
              <Parallax speed={5} className="content-left">
              <div className="image-container">
                <img src="/about/procon.jpg" alt="2023年11月" />
              </div>
            </Parallax>
          </div>

          <div className="content-row">
            <Parallax speed={-5} className="content-left">
              <div className="section">
                <h2>2024年4月、高専を中退</h2>
                <p>全国制覇後、学校関係者と争いになり中退。<br />
                  中卒となる。<br />
                  面接40社受けても受からなかったのが苦しかった。<br />
                </p>
              </div>
            </Parallax>
            <Parallax speed={5} className="content-right">
              <div className="image-container">
              
              </div>
            </Parallax>
          </div>

          <div className="content-row">
           
            <Parallax speed={-5} className="content-right">
              <div className="section">
                <h2>2024年4月、「革命前夜」結成</h2>
                <p>世界史界隈の知り合いとユニット、「革命前夜」を結成する。<br />
                  作曲、編曲、ギター、ベースを担当。<br />
                  虫恋チャンネルでも、「星空に願いを」として投稿。<br />
                </p>
              </div>
            </Parallax>
             <Parallax speed={5} className="content-left">
              <div className="image-container">
                <img src="/about/kakumei.jpg" alt="革命前夜" />
              </div>
            </Parallax>
          </div>

          <div className="content-row">
            <Parallax speed={-5} className="content-left">
              <div className="section">
                <h2>2024年9月、添乗員となる</h2>
                <p>大阪に引っ越し、添乗員として日本全国を飛び回った。<br />
                  不安定な毎日だったが、それでも楽しかった。<br />
                  人前で話すスキル、日本全国の地理、歴史について深く学べた。<br />
                </p>
              </div>
            </Parallax>
            <Parallax speed={5} className="content-right">
              <div className="image-container">
              
              </div>
            </Parallax>
          </div>

          <div className="content-row">
           
            <Parallax speed={-5} className="content-right">
              <div className="section">
                <h2>2025年1月、「VBR」始動</h2>
                <p>日本全国を飛び回るさなか、VRChatにてワールドを制作し、<br />
                  「BOAT RACE 虫恋」を開設。VRChat BOAT RACEが発足する。<br />
                  自宅でVRボートレースが出来るゲームがなかったこともあり、<br />
                  様々なユーザーが今日も走っている。<br />
                  2026/01/20現在、ワールドを訪れた人数は39492人。<br/>
                  お気に入り登録数は1842。選手登録人数は271人。<br />
                  グループの参加人数は573人と、VRChat内でも最大級のボートレースコミュニティとなっている。<br />
                  今日に至るまで最高責任者として運営を行っている。<br />
                </p>
              </div>
            </Parallax>
             <Parallax speed={5} className="content-left">
              <div className="image-container">
                <img src="/about/VBR.png" alt="VBR" />
              </div>
            </Parallax>
          </div>
        </div>
      </div>
    </ParallaxProvider>
  )
};
export default About;